import { Injectable } from '@angular/core';
import { DefaultNavbarComponent } from '../components/default-navbar/default-navbar.component';
import { ComponentProviderService } from '../../core/services/component-provider.service';

@Injectable({
  providedIn: 'root'
})
export class NavbarProviderService extends ComponentProviderService {

  constructor() {
    super(DefaultNavbarComponent);
  }
}
